/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown>, unit: NonNullable<unknown> }} Ui_Charts_Value_With_UnitInputs */

const en_us2_ui_charts_value_with_unit = /** @type {(inputs: Ui_Charts_Value_With_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.unit}`)
};

const pt_br2_ui_charts_value_with_unit = /** @type {(inputs: Ui_Charts_Value_With_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.unit}`)
};

const es_419_ui_charts_value_with_unit = /** @type {(inputs: Ui_Charts_Value_With_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.unit}`)
};

const pt_pt2_ui_charts_value_with_unit = /** @type {(inputs: Ui_Charts_Value_With_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.unit}`)
};

const fr_fr2_ui_charts_value_with_unit = /** @type {(inputs: Ui_Charts_Value_With_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.unit}`)
};

const de_de2_ui_charts_value_with_unit = /** @type {(inputs: Ui_Charts_Value_With_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.unit}`)
};

const it_it2_ui_charts_value_with_unit = /** @type {(inputs: Ui_Charts_Value_With_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.unit}`)
};

/**
* | output |
* | --- |
* | "{value} {unit}" |
*
* @param {Ui_Charts_Value_With_UnitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_charts_value_with_unit = /** @type {((inputs: Ui_Charts_Value_With_UnitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Charts_Value_With_UnitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_charts_value_with_unit(inputs)
	if (locale === "es-419") return es_419_ui_charts_value_with_unit(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_charts_value_with_unit(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_charts_value_with_unit(inputs)
	if (locale === "de-DE") return de_de2_ui_charts_value_with_unit(inputs)
	if (locale === "it-IT") return it_it2_ui_charts_value_with_unit(inputs)
	return en_us2_ui_charts_value_with_unit(inputs)
});
export { ui_charts_value_with_unit as "ui-charts.value_with_unit" }